/// <amd-module name="Test/TestPlansHubRefresh/TestCasesClonePanel/Redux/TestCasesClonePanelContracts" />
import { ITestHubRefreshAwareState } from "Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefresh/TestHubRefreshContracts";
import { TeamProjectReference, TeamProject } from "Tfs/Platform/Contracts/Core";
import { TestPlan, TestSuite } from "TestPlanCommon/Contracts/TestPlan";

export interface ITestCasesClonePanelAwareState extends ITestHubRefreshAwareState {
    testCasesClonePanelState: ITestCasesClonePanelState;
}

export interface ITestCasesClonePanelState {
    cloneInProgress: boolean;
    opId: number | undefined;
    mandatoryFieldUpdated: boolean;
    projectList: TeamProjectReference[];
    testPlanList: TestPlan[];
    testPlanListProject: string;
    suiteList: TestSuite[];
    testPlanSelectionErrorMessage: string;
    testSuiteSelectionErrorMessage: string;
    disableTestSuiteDropdown: boolean;
}